export const JourneyData = [
    {
        id:1,
        year:"2019",
        content:"Started my journey"
    },
    {
        id:2,
        year:"2020",
        content:"Worked as a freelance developer"
    },
    {
        id:3,
        year:"2020",
        content:"Got into Malhub_Ng"
    },
    {
        id:4,
        year:"2021",
        content:"Started my own path"
    }
]